'use strict';

angular.module('selfAccessRequestControllers')

.controller('SelfAccessRequestController',
            ['$scope', '$state', '$translate', 'topBar', 'selfAccessRequestService', 'empIdentity', 'selfAccessRequest',
    function ($scope, $state, $translate, topBar, selfAccessRequestService, empIdentity, selfAccessRequest) {

        // Load translation asynchronously to avoid race condition
        $translate('iam.selfAccessRequest.pageTitle').then(function(translation) {
            topBar.setTitleAndIcon(translation, 'fa-eye');
        });

        $scope.selfAccessRequest = selfAccessRequest;

        if (!$state.is('selfAccessRequest')) return;

        // No longer a self access request
        if (!selfAccessRequest.IsSelfAccessRequest) {
            $state.go('selfAccessRequest.noLongerSelfRequest', null, { location: 'replace' });
            return;
        }

        // Already Owned
        if (selfAccessRequest.IsSelfAccessRequestOwned) {
            
            if (selfAccessRequest.SelfRequestOwnerID !== empIdentity.EmployeeID) {
                $state.go('selfAccessRequest.ownedByOtherUser', null, { location: 'replace' });
                return;
            }

            $state.go(selfAccessRequest.SelfRequestPageRoute, null, { location: 'replace' });

            return;
        }

        // Take Ownership
        selfAccessRequestService
              .takeOwnershipOfSelfAccessRequest(selfAccessRequest.UserAccessRequestID)
              .then(function (req) {
                  $state.go(req.SelfRequestPageRoute, {
                      userAccessRequestId: req.UserAccessRequestID
                  }, { reload: true });
              });
}]);
